import { Grid, Box, Text, HStack, VStack } from '@postenbring/hedwig-react'
import { DimensionInput } from './form/inputs/DimensionInput'
import { CountryDropdown } from './form/inputs/CountryDropdown'
import { PostalCodeInput } from './form/inputs/PostalCodeInput'
import { ServiceTypeSelector } from './form/inputs/ServiceTypeSelector'
import { ResultDisplay } from './resultFeedback/ResultDisplay'
import { CalculateButton } from './form/CalculateButton'

export const CalculatorForm = ({ labels, serviceUrlCountries, serviceUrlPriceCalc }) => (
    <>
    <Grid span={{ initial: 12, large: 11 }} gapY='48-64'>
        <VStack gap="48-64" asChild>
            <Box asChild>
                <form>
                    <VStack gap="20-24">
                        <Text as="h2" variant="h2">{labels.service}</Text>
                        <ServiceTypeSelector labels={labels} />
                    </VStack>
                    <VStack gap="20-24">
                        <Text as="h2" variant="h2">{labels.destinationText}</Text>
                        <HStack gap="12">
                            <CountryDropdown labels={labels} serviceUrlCountries={serviceUrlCountries} />
                            <PostalCodeInput postalLabel={labels.postalLabel} />
                        </HStack>
                    </VStack>
                    <VStack gap="20-24">
                        <Text as="h2" variant="h2">{labels.dimensionText}</Text>
                        <DimensionInput labels={labels} />
                    </VStack>
                    <div><CalculateButton labels={labels} serviceUrlPriceCalc={serviceUrlPriceCalc} /></div>
                </form>
            </Box>
        </VStack>
        <ResultDisplay labels={labels} />
    </Grid>
    </>
)
